var parts = ['container', 'control', 'label', 'icon'];
function baseStyleControl(props) {
  var c = props.colorScheme;
  return {
    w: '100%',
    transitionProperty: 'box-shadow',
    transitionDuration: 'normal',
    border: '1px',
    borderColor: 'gray.200',
    borderRadius: 'sm',
    color: 'white',
    _checked: {
      bg: "".concat(c, ".400"),
      borderColor: "".concat(c, ".400"),
      color: 'white',
      _disabled: {
        borderColor: 'gray.200',
        bg: 'gray.200',
        color: 'gray.500'
      },
      _focus: {
        boxShadow: '0 0 2px',
        color: "".concat(c, ".400")
      }
    },
    _indeterminate: {
      bg: "".concat(c, ".400"),
      borderColor: "".concat(c, ".400"),
      color: 'white'
    },
    _disabled: {
      bg: 'gray.100',
      borderColor: 'gray.100'
    },
    _invalid: {
      borderColor: 'red.500',
      _checked: {
        bg: 'red.300'
      },
      _focus: {
        boxShadow: '0 0 2px',
        color: "red.400"
      }
    },
    _focus: {
      boxShadow: '0 0 2px',
      color: "".concat(c, ".400")
    }
  };
}
var baseStyleLabel = {
  userSelect: 'none',
  textStyle: 'label'
};
var baseStyleIcon = {
  transitionProperty: 'transform',
  transitionDuration: 'normal',
  color: 'white'
};
var baseStyle = function baseStyle(props) {
  return {
    icon: baseStyleIcon,
    control: baseStyleControl(props),
    label: baseStyleLabel
  };
};
var sizes = {
  sm: {
    control: {
      h: 4,
      w: 4
    },
    label: {
      fontSize: 'md'
    },
    icon: {
      fontSize: 'xs'
    }
  },
  md: {
    control: {
      w: 4,
      h: 4
    },
    label: {
      fontSize: 'md'
    },
    icon: {
      fontSize: 'xs'
    }
  },
  lg: {
    control: {
      w: 5,
      h: 5
    },
    label: {
      fontSize: 'xl'
    },
    icon: {
      fontSize: 'xs'
    }
  }
};
var defaultProps = {
  size: 'md',
  colorScheme: 'blue'
};
var Checkbox = {
  parts: parts,
  baseStyle: baseStyle,
  sizes: sizes,
  defaultProps: defaultProps
};
export { Checkbox as default };